import type { InterviewExperience } from "iq-interview_experiences/types";

interface OutcomeBadgeProps {
  outcome: InterviewExperience["outcome"];
  outcome_color: InterviewExperience["outcome_color"];
}

const colorClasses: Record<NonNullable<InterviewExperience["outcome_color"]>, string> = {
  green: "border-green-300 text-green-700 bg-green-50",
  yellow: "border-yellow-300 text-yellow-700 bg-yellow-50",
  red: "border-red-300 text-red-700 bg-red-50",
};

export function OutcomeBadge({ outcome, outcome_color }: OutcomeBadgeProps) {
  if (!outcome || !outcome_color) return null;

  return (
    <span
      title={outcome}
      className={`inline-flex max-w-full shrink-0 truncate whitespace-nowrap border px-3 py-1 text-xs font-medium rounded-full ${colorClasses[outcome_color]}`}
    >
      {outcome}
    </span>
  );
}
